import React from 'react';
import {
  Container,
  Row,
  Col,
  Badge,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  CardBody,
  Card,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Breadcrumb,
  BreadcrumbItem,
  Alert
} from 'reactstrap';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet';
import * as actions from '@src/store/actions';
import connect from 'react-redux/es/connect/connect';
import AddressHelper from '@src/components/Elements/AddressHelper/AddressHelper';
import AssociationModal from '../AssociationModal/AssociationModal';
import Remarks from './Remarks/Remarks';
import Addresses from './Addresses/Addresses';
import Policies from './Policies/Policies';
import Activities from '@components/Elements/Activites/Activities';
import ConfirmModal from '@src/components/ConfirmModal/ConfirmModal';
import { Link } from 'react-router-dom';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import Auth from '@src/components/Elements/Auth/Auth';

class AssociationView extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      modalActive: false,
      activateConfirmModalActive: false,
      activeTab: '1',
      flash: localStorage.getItem('associationFlash')
    };
    if (localStorage.getItem('associationFlash')) {
      localStorage.removeItem('associationFlash');
    }

    if (
      props.entity.id === undefined ||
      props.entity.id !== parseInt(props.id, 10)
    ) {
      props.getEntity(props.id);
    }
  }

  toggleModal = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render = () => {
    const { entity } = this.props;
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | Associations</title>
        </Helmet>
        {entity.id !== undefined &&
          this.props.entity.id === parseInt(this.props.id, 10) && (
            <React.Fragment>
              {this.props.loading && (
                <ProgressBox
                  text={'Loading ...'}
                  loader={'transparent-background'}
                />
              )}
              <div>
                <Breadcrumb className={'pt-0'} listClassName={'pt-0 pl-0'}>
                  <BreadcrumbItem>
                    <Link to={'/associations'}>Associations</Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active>{entity.name}</BreadcrumbItem>
                </Breadcrumb>
              </div>
              <Row>
                <Col>
                  <div className={'float-left mr-3'}>
                    <FontAwesomeIcon
                      icon={['fas', 'home']}
                      className={'fa-3x'}
                    />
                  </div>
                  <div className={'color-blue font-md float-left text-break'}>
                    {entity.name}{' '}
                    <Badge
                      color={entity.status === 1 ? 'success' : 'info'}
                      className={
                        'font-xs ml-2 d-inline-block position-relative'
                      }
                      style={{ top: '-4px' }}
                    >
                      {entity.status === 1 ? 'Active' : 'Inactive'}
                    </Badge>
                    {entity.common_area_only && (
                      <Badge
                        color={'warning'}
                        className={
                          'font-xs ml-2 d-inline-block position-relative'
                        }
                        style={{ top: '-4px' }}
                      >
                        Common Area Only - No EOIs.
                      </Badge>
                    )}
                    <div className={'color-blue font-sm'}>
                      {entity.association_type.name}
                    </div>
                  </div>
                  <Auth action={'Associations::edit'}>
                    <div className={'float-right'}>
                      <UncontrolledDropdown>
                        <DropdownToggle caret>Actions</DropdownToggle>
                        <DropdownMenu right>
                          <DropdownItem
                            onClick={() => this.toggleModal('modalActive')}
                          >
                            Edit Details
                          </DropdownItem>
                          <DropdownItem
                            onClick={() =>
                              this.toggleModal('activateConfirmModalActive')
                            }
                          >
                            {entity.status === 1 ? 'Deactivate' : 'Activate'}
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </Auth>
                </Col>
              </Row>

              <Row className={'mt-3'}>
                <Col>
                  <Card>
                    <CardBody>
                      <div className={'pb-3'}>
                        {this.state.flash && (
                          <Alert color={'success'}>{this.state.flash}</Alert>
                        )}
                        <Table size={'sm'} borderless>
                          <tbody>
                            <tr>
                              <th className={'w-25'}>Address</th>
                              <td>
                                <AddressHelper {...entity} />
                              </td>
                            </tr>
                            <tr>
                              <th>Notes</th>
                              <td>{entity.notes}</td>
                            </tr>
                            <tr>
                              <th>&nbsp;</th>
                              <td>&nbsp;</td>
                            </tr>
                            <tr>
                              <th>Management Company</th>
                              <td>
                                {entity.management_company !== null ? (
                                  <Link
                                    to={
                                      '/management-companies/' +
                                      entity.management_company.id
                                    }
                                  >
                                    {entity.management_company.name}
                                  </Link>
                                ) : (
                                  '---'
                                )}
                              </td>
                            </tr>
                            {entity.management_company !== null && entity.management_company.contact_name.length >
                              0 && (
                              <tr>
                                <th>Contact Person</th>
                                <td>
                                  {entity.management_company.contact_name}
                                </td>
                              </tr>
                            )}
                            {entity.management_company !== null && entity.management_company.phone.length > 0 && (
                              <tr>
                                <th>Phone Number</th>
                                <td>{entity.management_company.phone}</td>
                              </tr>
                            )}
                            <tr>
                              <th>Address</th>
                              <td>
                                {entity.management_company !== null ? (
                                  <AddressHelper
                                    {...entity.management_company}
                                  />
                                ) : (
                                  '---'
                                )}
                              </td>
                            </tr>
                            <tr>
                              <th>Developer</th>
                              <td>
                                {entity.developer !== null ? (
                                  <Link
                                    to={`/developers/${entity.developer.id}`}
                                  >
                                    {entity.developer.name}
                                  </Link>
                                ) : (
                                  '---'
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>

                      <Row className={'pb-5'}>
                        <Col>
                          <Nav tabs>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: this.state.activeTab === '1',
                                  pointer: true
                                })}
                                onClick={() => {
                                  this.toggle('1');
                                }}
                              >
                                Addresses
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: this.state.activeTab === '2',
                                  pointer: true
                                })}
                                onClick={() => {
                                  this.toggle('2');
                                }}
                              >
                                Policies and Remarks
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: this.state.activeTab === '4',
                                  pointer: true
                                })}
                                onClick={() => {
                                  this.toggle('4');
                                }}
                              >
                                Documents
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: this.state.activeTab === '5',
                                  pointer: true
                                })}
                                onClick={() => {
                                  this.toggle('5');
                                }}
                              >
                                History
                              </NavLink>
                            </NavItem>
                          </Nav>

                          <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="1">
                              <div
                                className={
                                  'p-3 border-left border-right border-bottom'
                                }
                              >
                                <Addresses
                                  entity={this.props.entity}
                                  onSubmit={this.props.onToggleEdit}
                                  loading={this.props.loading}
                                />
                              </div>
                            </TabPane>
                            <TabPane tabId="2">
                              <div
                                className={
                                  'p-3 border-left border-right border-bottom'
                                }
                              >
                                {this.state.activeTab === '2' && (
                                  <Policies
                                    entityId={this.props.id}
                                    entity={this.props.entity}
                                    onSubmit={this.props.onToggleEdit}
                                    getEntity={() =>
                                      this.props.getEntity(this.props.id)
                                    }
                                  />
                                )}
                              </div>
                            </TabPane>
                            <TabPane tabId="4">
                              <div
                                className={
                                  'p-3 border-left border-right border-bottom'
                                }
                              >
                                <Remarks
                                  entityId={this.props.id}
                                  entity={this.props.entity}
                                  associationSuccess={
                                    this.props.associationSuccess
                                  }
                                  onToggleEdit={this.props.onToggleEdit}
                                  loading={this.props.loading}
                                />
                              </div>
                            </TabPane>

                            <TabPane tabId="5">
                              <div
                                className={
                                  'p-3 border-left border-right border-bottom'
                                }
                              >
                                <Activities
                                  activities={this.props.entity.activities}
                                />
                              </div>
                            </TabPane>
                          </TabContent>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <AssociationModal
                entity={this.props.entity}
                history={this.props.history}
                isActive={this.state.modalActive}
                toggle={() => this.toggleModal('modalActive')}
                associationTypes={this.props.associationTypes}
              />
            </React.Fragment>
          )}
        <ConfirmModal
          isActive={this.state.activateConfirmModalActive}
          toggle={() => this.toggleModal('activateConfirmModalActive')}
          title={'Confirmation'}
          body={
            entity.status === 1
              ? 'Please confirm to deactivate this association.'
              : 'Please confirm to activate this association.'
          }
          confirmLabel={'Confirm'}
          confirmAction={() => {
            this.props.onToggleEdit(entity.id, {
              status: entity.status === 1 ? 0 : 1
            });
            this.toggleModal('activateConfirmModalActive');
          }}
        />
      </Container>
    );
  };
}

const mapStateToProps = state => {
  return {
    entity: state.association.viewItem,
    loading: state.association.loading,
    associationTypes: state.auth.association_types
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getEntity: entityId => dispatch(actions.getAssociation(entityId)),
    onToggleEdit: (entityId, postData) =>
      dispatch(actions.editAssociation(entityId, postData)),
    associationSuccess: payload => dispatch(actions.associationSuccess(payload))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssociationView);
